import React from 'react';
import { UpgradePrompt } from 'components/entitlements';
import { FEATURES, useOpenUpgradeForFeature } from 'modules/entitlements';
import { cn } from 'lib/utils';

/** The body of a panel whose figures come from the PRO analytics endpoints, on plans without them. */
export function AdvancedUpgradeNotice({ className }: { className?: string }) {
  const openUpgrade = useOpenUpgradeForFeature();
  return (
    <div data-analytics-upgrade className={cn('flex items-center justify-center px-4 py-8 text-center', className)}>
      <UpgradePrompt
        variant="inline"
        featureKey={FEATURES.ADVANCED_ANALYTICS}
        requiredPlan="PRO"
        onUpgrade={() => openUpgrade(FEATURES.ADVANCED_ANALYTICS)}
        className="flex-wrap justify-center"
      />
    </div>
  );
}

export default AdvancedUpgradeNotice;
